import React from 'react';

// Reference: https://github.com/uber/baseweb/blob/master/src/popover/popover.js#L362
export const getAnchorFromChildren = (children: React.ReactNode) => {
  const childArray = React.Children.toArray(children);

  if (childArray.length !== 1) {
    console.error(
      `[PopoverButton] Exactly 1 child must be passed to Popover, found ${childArray.length} children`,
    );
  }

  return childArray[0];
};
